import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import scribeTheme from "./theme/scribeTheme";
import AppContent from "./components/layout/AppContent";
import { PaddleProvider } from "./contexts/PaddleContext";
import "./App.css";
import BrandHelmet from "./components/BrandHelmet";
import { telemetryClient } from "./services/telemetryClient";

const App: React.FC = () => {
  useEffect(() => {
    telemetryClient.log("app.firstRender", {
      metadata: { elapsedMs: Math.round(performance.now()) },
    });
  }, []);

  return (
    <ThemeProvider theme={scribeTheme}>
      <CssBaseline />
      <PaddleProvider>
        <Router>
          <BrandHelmet />
          <AppContent />
        </Router>
      </PaddleProvider>
    </ThemeProvider>
  );
};

export default App;
